
export const excluded = [
  'AU', //Australia
  'BN', //Brunei
  'CC', //Coco Islands
  'CX', //Christmas Islands
  'ID', //Indonesia
  'FJ', //Fiji
  'FM', //Micronesia
  'KZ', //Kazakhstan
  'MH', //Marshall Islands
  'MY', //Malaysia
  'NZ', //New Zealand
  'PW', //Palau
  'PG', //Papua New Guinea
  'PH', //Philippines
  'RU', //Russia
  'SG', //Singapore
  'TH', //Thailand
  'TO', //Tonga
  'VU', //Vanuatu
  'WF', //Wallis and Futuna
  'WS', //Samoa
];

// ordre d'affichage France Guadeloupe Martinique Réunion Mayotte Guyane
export const preferredCountriesOrder = ['FR', 'GP', 'MQ', 'RE', 'YT', 'GF', '|', '...']; // pour ajouter un nouveau pays dans la liste


